<template>
  <div class="notice-category">
    <h2>公告分类</h2>
    <el-tag
      :effect="active === 'all' ? 'dark' : 'plain'"
      @click="changeCategory('all')"
      >全部</el-tag
    >
    <el-tag
      :effect="active === 'sz' ? 'dark' : 'plain'"
      @click="changeCategory('sz')"
      >市州动态</el-tag
    >
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 'all'
    }
  },
  mounted() {
    const _active = this.$route.query.category
    if (_active) {
      this.active = _active
    }
  },
  methods: {
    changeCategory(type) {
      if (type === 'sz') {
        this.active = 'sz'
        if (this.$route.fullPath !== '/list?newstype=notice&category=sz') {
          this.$router.push('/list?newstype=notice&category=sz')
        }
      } else {
        this.active = 'all'
        if (this.$route.fullPath !== '/list?newstype=notice') {
          this.$router.push('/list?newstype=notice')
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.notice-category {
  background-color: #fff;
  padding: 20px 20px 10px 20px;
  border-bottom: 1px solid #f1f1f1;
  h2 {
    color: #555;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 5px;
  }
}
.el-tag {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/list/noticeCategory.vue